import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context("./modules", true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

const store = new Vuex.Store({
  modules,
  getters,
  plugins: [
    createPersistedState()
    // 不需要持久化的状态
    // createPersistedState({
    //   storage: window.sessionStorage,
    // }),
    //需要持久化的状态
    // createPersistedState({
    //   storage: window.localStorage,
    //   paths: ["user.usid","user.roles","user.usname","user.realroles","user.menus","user.roles","user.receiveMdsPageCheckListBox","user.dataTheme"],
    // }),
  ],
});

export default store;
